import { createActions } from 'redux-actions';

export const {
  startApp,
  startAppFailure,
  startAppTimeout,
  startAppCancel,
  startAppComplete
} = createActions({
  START_APP: historyObject => historyObject,
  START_APP_COMPLETE: response => response,
  START_APP_FAILURE: () => undefined,
  START_APP_TIMEOUT: () => undefined,
  START_APP_CANCEL: () => undefined
});



// WEBPACK FOOTER //
// ./src/actions/StartApp.Actions.js